import React from 'react';
import './About.css';
import AboutSkillCard from './AboutSkillCard';
import SectionTitle from './SectionTitle';

const About = () => {
  return (
    <div className="about-container">

      {/* Hero */}
      <section className="about-hero">
        <div className="hero-content">
          <h1>Robson Medeiros</h1>
          <h2>Unity Game Developer | Fullstack Developer | Real-Time Systems</h2>
          <p className="hero-location">📍 Rio de Janeiro, Brazil</p>
        </div>
      </section>

      {/* Bio */}
      <section className="about-bio">
        <div className="bio-text">
          <p>
            Fullstack developer with 5+ years of experience building interactive applications and games, 
            working across Unity gameplay systems, backend architecture, and real-time systems.
          </p>

          <p>
            I develop complete solutions — from gameplay mechanics and AI systems to scalable backend services 
            and cloud infrastructure — supporting both single-player and multiplayer experiences across WebGL, 
            Mobile, and Desktop platforms.
          </p>

          <p>
            My work focuses on performance, scalability, and clean system design, combining game development 
            with modern web technologies.
          </p>
        </div>
      </section>

      {/* Skills */}
      <section className="about-skills">
        <SectionTitle>Tech Stack & Expertise</SectionTitle>

        <div className="skills-grid">
          <AboutSkillCard
            title="Game Development"
            items={[
              "Unity 3D/2D (C#)",
              "Gameplay Systems (FPS/TPS)",
              "AI, Bots & Pathfinding",
              "Singleplayer & Multiplayer",
              "WebGL Optimization",
              "Mobile Android",
              "Desktop"
            ]}
          />

          <AboutSkillCard
            title="Backend & Networking"
            items={[
              "Node.js & TypeScript",
              "WebSockets (Real-Time)",
              "TCP / UDP",
              "Matchmaking & Sync Systems",
              "REST APIs (Express)"
            ]}
          />

          <AboutSkillCard
            title="Frontend & Cloud"
            items={[
              "React.js & Context API",
              "Firebase (Auth & Database)",
              "Real-Time Applications",
              "GCP / Cloud VM",
              "Scalable Architectures"
            ]}
          />
        </div>
      </section>

      {/* Project */}
      <section className="about-project">
        <div className="project-card">
          <h3>🚀 Current Project: Social Multiplayer Platform</h3>

          <p>
            Currently developing a real-time social WebGL game inspired by PKXD and Roblox, 
            focused on player interaction, shared environments, and live communication.
          </p>

          <p>
            The project already includes real-time synchronization (position, rotation, animations), 
            chat system, and a scalable backend foundation.
          </p>

          <div className="cta-box">
            <p><strong>Status:</strong> Functional prototype with ongoing development.</p>

            <p className="investor-note">
              📢 <strong>Open to Investment:</strong> Looking for partners to scale production 
              and expand the platform into a full social gaming ecosystem.
            </p>

            <a href="mailto:robsonmedeirosoficial@gmail.com" className="contact-btn">
              Get in Touch
            </a>
          </div>
        </div>
      </section>

    </div>
  );
};

export default About;